/**
 * Text manipulation utilities
 */

/**
 * Decodes HTML entities in a string
 * @param str - String containing HTML entities to decode
 * @returns Decoded string with HTML entities converted to their character equivalents
 * @example
 * decodeHtmlEntities("&amp;lt;hello&amp;gt;") // "<hello>"
 * decodeHtmlEntities("&amp;quot;test&amp;quot;") // '"test"'
 */
export const decodeHtmlEntities = (str: string): string => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = str;
  return textarea.value;
};

/**
 * Encodes HTML characters in a string as HTML entities
 * @param str - String to encode
 * @returns String with HTML characters encoded as entities
 * @example
 * encodeHtmlEntities("<hello>") // "&lt;hello&gt;"
 * encodeHtmlEntities('"test"') // "&quot;test&quot;"
 */
export const encodeHtmlEntities = (str: string): string => {
  const textarea = document.createElement("textarea");
  textarea.textContent = str;
  return textarea.innerHTML;
};